<script lang="ts">
  import { locale, localeMetadata, type Locale } from "$lib/i18n";

  const flagCode: Record<Locale, string> = { en: 'gb', de: 'de' };
  const otherLocale: Record<Locale, Locale> = { en: 'de', de: 'en' };

  function toggle() {
    locale.set(otherLocale[$locale]);
  }
</script>

<button
  class="focus:bg-accent focus:text-accent-foreground hover:bg-accent hover:text-accent-foreground outline-hidden flex select-none items-center rounded-sm px-2 py-1 text-sm font-medium ml-auto cursor-pointer"
  onclick={toggle}
  title={localeMetadata[otherLocale[$locale]].label}
>
  <span class="fi fi-{flagCode[otherLocale[$locale]]}" aria-hidden="true"></span>
  <span class="sr-only">{localeMetadata[otherLocale[$locale]].label}</span>
</button>
